import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Calendar60 } from "@faire/web--source/slate/icons/CalendarDays";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import CuratedSelectionIcon from "@faire/retailer/icons/Collections.svg";
import FreeReturnsIcon from "@faire/retailer/icons/FreeReturn.svg";
import { termsOfServiceLinkFormatting } from "@faire/retailer/views/product/Components/__internal__/utils";
var MobileFaireDirectPerksCardBase = function() {
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount;
    var faireDirectBrandName = faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: "center",
                children: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "v9Jch7",
                    defaultMessage: [
                        {
                            type: 1,
                            value: "brandName"
                        },
                        {
                            type: 0,
                            value: " invited you to Faire!"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        brandName: faireDirectBrandName
                    })
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "1RE//R",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Lock in "
                        },
                        {
                            type: 1,
                            value: "promoMoney"
                        },
                        {
                            type: 0,
                            value: " off your first order with "
                        },
                        {
                            type: 1,
                            value: "brandCompanyName"
                        },
                        {
                            type: 0,
                            value: "*"
                        }
                    ],
                    values: {
                        promoMoney: formattedFixedBasedAmount,
                        brandCompanyName: faireDirectBrandName !== null && faireDirectBrandName !== void 0 ? faireDirectBrandName : ""
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "hl/GpJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Plus, join thousands of retailers shopping unique vendors on the Faire marketplace."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Perks, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "labelSansRegular",
                color: Core.text.subdued,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "DRKDn7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Eligible for new retailers only. By proceeding, you agree to our "
                        },
                        {
                            type: 8,
                            value: "TextLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Terms of Service"
                                }
                            ]
                        }
                    ],
                    values: {
                        TextLinkFormatting: termsOfServiceLinkFormatting
                    }
                })
            })
        ]
    });
};
var Perks = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var perks = [
        {
            id: 1,
            icon: /*#__PURE__*/ _jsx("img", {
                src: CuratedSelectionIcon,
                alt: "Easy reordering with year-round shopping",
                style: {
                    height: "20px",
                    width: "20px"
                }
            }),
            text: strictLocalize({
                id: "Hmuxpm",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Easy reordering with year-round shopping"
                    }
                ]
            })
        },
        {
            id: 2,
            icon: /*#__PURE__*/ _jsx("img", {
                src: FreeReturnsIcon,
                alt: "Free returns for risk-free buying",
                style: {
                    height: "20px",
                    width: "20px"
                }
            }),
            text: strictLocalize({
                id: "OTFoIY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Free returns for risk-free buying"
                    }
                ]
            })
        },
        {
            id: 3,
            icon: /*#__PURE__*/ _jsx(Calendar60, {
                height: "20px",
                width: "20px",
                titleAccess: "60-day payment terms"
            }),
            text: strictLocalize({
                id: "yTK45b",
                defaultMessage: [
                    {
                        type: 0,
                        value: "60-day payment terms"
                    }
                ]
            })
        }
    ];
    return /*#__PURE__*/ _jsx(Column, {
        gap: "3x",
        children: perks.map(function(perk) {
            return /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        children: perk.icon
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Perk, {
                        children: perk.text
                    })
                ]
            }, perk.id);
        })
    });
};
export var MobileFaireDirectPerksCard = observer(MobileFaireDirectPerksCardBase);
var Wrapper = styled(Column).withConfig({
    componentId: "sc-dc5613d4-0"
})([
    "background-color:",
    ";padding:",
    ";"
], Decorative.tint.neutral, getSpacing("3x", "3x", "4x"));
var Icon = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-dc5613d4-1"
})([
    "width:40px;height:40px;border-radius:50%;background-color:",
    ";"
], Core.surface.inverse);
var Perk = styled(Typography).withConfig({
    componentId: "sc-dc5613d4-2"
})([
    "max-width:164px;"
]);
